export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/quote-marks.2f7d1141.svg","height":236,"width":323};